<template>
  <div :class="['dropdown', isOpen ? 'dropdown--open' : '']" @click="open('click')" @mouseover="open('hover')" @mouseleave="close('hover')">
    <slot name="button"></slot>
    <slot name="submenu"></slot>
  </div>
</template>

<script>

export default {
  props: {
    trigger: {
      default: 'hover'
    }
  },
  data() {
		return {
			isOpen: false,
		}
	},
  methods: {
    open: function(eventtype){

      if( this.trigger == eventtype ){
        this.isOpen = true;
      }

    },
    close: function(eventtype){
      if( this.trigger == eventtype ){
        this.isOpen = false;
      }
    }
  }
}

</script>
